import { type ReactNode, useEffect } from 'react';
import { useStepperDialog } from '@ics-portal/guardian';
import { hasDirtyFields } from '@utils/hasDirtyFields';
import { useProjectFormContext } from '../../ProjectForm';
import { ProjectFormStandards } from './ProjectFormStandards';

interface ProjectFormStandardsStepProps {
    isEditMode?: boolean;
}

export function ProjectFormStandardsStep({
    isEditMode,
}: ProjectFormStandardsStepProps): ReactNode {
    const { registerProceed, setPrimaryDisabled } = useStepperDialog();
    const { form } = useProjectFormContext();
    const {
        formState: { dirtyFields },
    } = form;

    const hasUnsavedChanges = hasDirtyFields(dirtyFields);
    const isEdit = Boolean(isEditMode);

    useEffect(() => {
        if (isEdit) {
            registerProceed(() => true);
            return;
        }

        registerProceed(() => true);
    }, [registerProceed, isEdit]);

    useEffect(() => {
        if (isEdit) {
            setPrimaryDisabled(!hasUnsavedChanges);
            return;
        }

        setPrimaryDisabled(false);
    }, [setPrimaryDisabled, hasUnsavedChanges, isEdit]);

    return <ProjectFormStandards isEditMode={isEditMode} />;
}
